export function buildBadgeLabel(equipmentName: string): string {
  return `Applies to: ${equipmentName}`;
}
